<template>
  <b-card no-body class="mb-50">
    <b-card-header class="pb-50">
      <h5>Tiêu chí</h5>
    </b-card-header>
    <b-card-body>
      <b-row>
        <!-- <b-col cols="12" md="12" class="mb-md-0 mb-2">
          
        </b-col> -->
        <b-col md="4" class="mb-md-0">
          <b-form-group>
            <label>Bắt đầu</label>
            <flat-pickr
              v-model="startDate"
              class="form-control"
              :config="{
                wrap: true,
                allowInput: true,
                dateFormat: 'Y-m-d',
                altInput: true,
                altFormat: 'd/m/Y',
              }"
            />
          </b-form-group>
        </b-col>
        <b-col md="4" class="mb-md-0">
          <b-form-group>
            <label>Kết thúc</label>
            <flat-pickr
              v-model="endDate"
              class="form-control"
              :config="{
                wrap: true,
                allowInput: true,
                dateFormat: 'Y-m-d',
                altInput: true,
                altFormat: 'd/m/Y',
              }"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12" md="4" class="mb-md-0 mb-2">
          <label>Trạng thái</label>
          <v-select
            class="w-100 p-0"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="listStatus"
            :reduce="(val) => val.key"
            v-model="status"
            label="value"
            :clearable="false"
          />
        </b-col>
        <b-col cols="12" md="4" class="mb-md-0 mb-2">
          <label>Đơn vị sử dụng</label>
          <treeselect
            v-on:select="formatDonVis"
            :options="options"
            value-format="id"
            v-model="value"
            :clearable="true"
            :searchable="true"
            :show-count="true"
            :default-expand-level="1"
            :normalizer="normalizer"
            placeholder="Chọn đơn vị"
          />
        </b-col>
        <b-col md="4">
          <b-form-group>
              <label label-for="userName">
                  Tài khoản  (UserName)<span style="color: red"></span>
              </label>
            <b-form-input
              id="userName"
              v-model="userName"
              trim
              placeholder="Nhập thông tin"
            />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group>
            <label label-for="fullName"
              >Họ và tên <span style="color: red"></span
            ></label>
            <b-form-input
              id="fullName"
              v-model="fullName"
              trim
              placeholder="Nhập thông tin"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="d-flex justify-content-center">
        <b-button
          size="sm"
          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
          variant="primary"
          @click="changeFilter()"
        >
          <feather-icon icon="SearchIcon" /> Tìm kiếm
        </b-button>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardBody,
  BRow,
  BCol,
  BFormInput,
  BFormGroup,
  BButton,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import store from "@/store";
import Treeselect from "@riophae/vue-treeselect";
import { PhongBanGetList } from "@/services/api/DefaultTemplate/PhongBanService";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BFormInput,
    BFormGroup,
    BButton,
    vSelect,
    Treeselect,
    flatPickr,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      // define the default value
      value: null,
      userName: null,
      fullName: null,
      startDate: null,
      endDate: null,
      status: false,
      listPhongBan: [],
      listStatus: [
        {
          key: true,
          value: "Thành công",
        },
        {
          key: false,
          value: "Thất bại",
        },
      ],
    };
  },
  watch: {
    // defaultOption() {
    //   this.value = this.defaultOption;
    //   // console.log("this.value", this.value);
    // },
  },
  created() {
    // this.changeFilter();
  },
  methods: {
    formatDonVis(node, instanceId) {},
    normalizer(node) {
      if (node.children == null || node.children == "null") {
        delete node.children;
      }
    },
    // onInput(val) {
    //   this.$emit("fetch-data", { donViId: val });
    //   // PhongBanGetList(val.id).then((response) => {
    //   //   // console.log("response", response);
    //   //   this.listPhongBan = response.data;
    //   // });
    // },
    changeFilter() {
      let filter = {
        donViId: this.value,
        fullName: this.fullName,
        email: this.userName,
        status: this.status,
        startDate: this.startDate,
        endDate: this.endDate,
      };
      this.$emit("fetch-data", filter);
    },
  },
  props: {
    defaultOption: {
      type: String,
    },
    options: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
